import React, { useContext } from "react";
import { Segment } from "semantic-ui-react";
import { StopObject } from "../Types";
import { MissionContext } from "./MissionWorkflowComponent";
import { ObjectStateComponent } from "./ObjectStateComponent";

export const StateComponent = (props: { id: number, buttons: React.ReactNode[], objectStates: React.ReactNode[], taskMode: boolean }) => {
    const { mission } = useContext(MissionContext)
    // TODO: think more; what do do for VEA? The UI that asks for the current stop? should we have an iteration?
    // it's clear that we won't ever want (on mobile) to see all the stops.
    // however, in the "editor mode", from desktop, this is not the case
    // maybe there will be other things different on desktop? E.g. I don't want to receive + have to answer to questions
    const stop = mission.stops.filter((stop: StopObject) => stop.id === parseInt(mission.currentStopId))[0];

    return mission.currentState.id === props.id && (
        <>
            {props.taskMode ? (
                <>
                    {props.buttons.map((button, index) => (
                        <React.Fragment key={index}>{button}</React.Fragment>
                    ))}
                </>
            ) : (<>
                {stop && <Segment data-testid={`stop-info`}>
                    <>
                        <b>{stop.address.name}</b>
                        {stop.objectActions[0].data.flightInfo.ifubs && (
                            <b> IFUBS </b>
                        )}
                        <b> {getTaskTypeSum(stop)} </b>
                        <b> {mission?.type.name} </b>
                    </>
                    {props.objectStates && mission.objectActionGroups.map((task, index) => {
                        const objectStateIndex = props.objectStates.findIndex(e => {
                            if (typeof e === 'object' && e !== null && 'props' in e) {
                                if (e.props.id === task.object.currentState.id) {
                                    return true
                                } else return null
                            } else return null
                        })
                        return <ObjectStateComponent key={index} objectState={props.objectStates[objectStateIndex]} task={task} />
                    })}
                </Segment>}
                {props.buttons.map(button => button)}
            </>
            )}
        </>
    )
}

function getTaskTypeSum(stop: StopObject) {
    const sum: { [key: string]: number } = {};
    if (stop) {
        //Check if stop is not null
        //For each objecAction in stop
        stop.objectActions.forEach((object) => {
            //Get the value of object.data.type
            const type = object.data.type;
            //Get the value of object.data.quantity
            const quantity = object.data.quantity;

            if (!sum[type]) {
                /*if the key with the type doesn't exist in the object sum.
                 It initialise that key with the type and the quantity  */
                sum[type] = quantity

            } else {
                /* Else if the key already exist, it will add
                the quantity to the value already inside the key */
                sum[type] += quantity
            }
        })
    }
    if (sum) {
        let formattedSum = '';
        /* For each key in the object sum, it will format the data
        in a string in the desired order */
        Object.keys(sum).forEach((type) => {
            formattedSum += `${sum[type]} ${type} - `;
        });
        // At the end of the process, it removes the last "-"
        formattedSum = formattedSum.slice(0, -3);
        //returns the processed value
        return formattedSum;
    }
}